import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Annotate = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5ZM4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6ZM16.3817 8.82297C16.56 8.61217 16.5337 8.29668 16.3229 8.1183C16.1121 7.93993 15.7966 7.96622 15.6183 8.17703L10.4693 14.2622L8.35352 12.1464C8.15826 11.9512 7.84167 11.9512 7.64641 12.1464C7.45115 12.3417 7.45115 12.6583 7.64641 12.8536L10.1464 15.3536C10.2453 15.4524 10.381 15.5054 10.5207 15.4996C10.6604 15.4938 10.7913 15.4297 10.8817 15.323L16.3817 8.82297Z"
        fill={color}
      />
    </svg>
  )
})

export default Annotate
